export const LoginDataEN = {
  "jcr:primaryType": "cq:PageContent",
  "jcr:createdBy": "admin",
  "title": "Log in",
  "cq:template": "/apps/gdocs/templates/page-create-case",
  "jcr:language": "en",
  "cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
  "jcr:created": "Wed May 09 2018 11:22:21 GMT+0000",
  "cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
  "cq:cloudserviceconfigs": [
    "[]"
  ],
  "sling:resourceType": "gdocs/components/pages/create-case",
  "cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
  "cq:lastModifiedBy": "admin",
  "par": {
    "jcr:primaryType": "nt:unstructured",
    "sling:resourceType": "wcm/foundation/components/parsys",
    "static_text_customer_guide": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "label": "Opens in new window",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "HSBC Global Documentation Manager Customer Guide",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "static_text_sow_guide": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "label": "Opens in new window",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "GLS Statement of Work Customer Guide",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "static_text_introTitle": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "introTitle",
      "text": "A portal to manage your documentation relating to your account and cash management products from HSBC.",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "static_text_introDescription": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "description": "If you have any problems using or accessing this service please contact your HSBC representative who is working with you on this case.",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "introDescription",
      "text": "Log on to track your request and to complete the necessary information. Documentation can be produced and executed to fulfil your request.",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "info_graphic_informationToHand": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Have information to hand",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "informationToHand",
      "text": "Both HSBC and you will need the relevant information for us to provide account, E-Channel and other products to create the documentation to proceed. Mandatory information will ensure the correct documents are included. Optional information will assist with the set up of your product.",
      "sling:resourceType": "gdocs/components/content/info_graphic"
    },
    "info_graphic_saveAsYouGo": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Save as you go",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "saveAsYouGo",
      "text": "We understand form filling can be tiresome, so we have broken them down into digestable parts, so you can easily save your progress.",
      "sling:resourceType": "gdocs/components/content/info_graphic"
    },
    "info_graphic_signDocuments": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Sign documents and track your progress to the point of document execution.",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "signDocuments",
      "text": "The status of each section is easy to track for you and HSBC so that any delays can be minimised.",
      "sling:resourceType": "gdocs/components/content/info_graphic",
      "sow-title": "Global Liquidity Solutions – Statement of Work.",
      "sow-text": "Review and approve your Statement of Work for your Liquidity products from HSBC."
    },
    "static_text_passwordText": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "To access the portal please request your Log on details from the HSBC contact managing your case.",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "text_box_emailAddress": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Email address",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "emailAddress",
      "type": "email",
      "sling:resourceType": "gdocs/components/content/text_box",
      "shortDescription": "Please enter Email address"
    },
    "text_box_password": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Password",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "password",
      "type": "password",
      "sling:resourceType": "gdocs/components/content/text_box",
      "shortDescription": "Please enter password"
    },
    "static_text_forgottenPasswordLink": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "Forgotten password",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "checkbox_termsAndConditions": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Terms and Conditions",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "termsAndConditions",
      "text": "I agree to the",
      "sling:resourceType": "gdocs/components/content/checkbox",
      "shortDescription": "Please accept Terms and Conditions"
    },
    "text_box_generalInformation": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "You have entered an incorrect Email address or password combination",
      "contactText": "Please contact your HSBC staff representative who is dealing with your case, who will arrange for a new password to be sent to you.",
      "sling:resourceType": "gdocs/components/content/text_box"
    },
    "button_logOn": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "logOn",
      "text": "Log on",
      "sling:resourceType": "gdocs/components/content/button"
    }
  }
}

export const LoginDataES = {
  "jcr:primaryType": "cq:PageContent",
  "jcr:createdBy": "admin",
  "title": "Log in",
  "cq:template": "/apps/gdocs/templates/page-create-case",
  "jcr:language": "en",
  "cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
  "jcr:created": "Wed May 09 2018 11:22:21 GMT+0000",
  "cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
  "cq:cloudserviceconfigs": [
    "[]"
  ],
  "sling:resourceType": "gdocs/components/pages/create-case",
  "cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
  "cq:lastModifiedBy": "admin",
  "par": {
    "jcr:primaryType": "nt:unstructured",
    "sling:resourceType": "wcm/foundation/components/parsys",
    "static_text_customer_guide": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "label": "Se abre en una ventana nueva",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "HSBC Global Documentation Manager Customer Guide",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "static_text_sow_guide": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "label": "Opens in new window",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "GLS Statement of Work Customer Guide",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "static_text_introTitle": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "introTitle",
      "text": "Un portal para gestionar la documentación relativa a sus cuentas y productos de gestión de efectivo de HSBC.",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "static_text_introDescription": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "description": "If you have any problems using or accessing this service please contact your HSBC representative who is working with you on this case.",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "introDescription",
      "text": "Inicie sesión para hacer el seguimiento de su solicitud y completar la información necesaria.  Se podrá emitir y ejecutar la documentación para cumplir su solicitud.",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "info_graphic_informationToHand": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Tenga la información a mano",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "informationToHand",
      "text": "Tanto HSBC como usted necesitarán la información pertinente para que le proporcionemos una cuenta, un canal electrónico y otros productos para crear la documentación necesaria para continuar.",
      "sling:resourceType": "gdocs/components/content/info_graphic"
    },
    "info_graphic_saveAsYouGo": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Guardado sobre la marcha",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "saveAsYouGo",
      "text": "Con el fin de mejorar el proceso de rellenar formularios, tanto usted como el personal de HSBC podrán guardar el progreso a medida que completen la documentación conjuntamente.  Cuando lo hayan completado todo, se podrán crear los documentos finales.  Cuando una sección aparezca como completa, revísela para asegurarse de que los detalles son correctos y verifique si hay más datos que pueda rellenar para optimizar la experiencia en línea.",
      "sling:resourceType": "gdocs/components/content/info_graphic"
    },
    "info_graphic_signDocuments": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Sign documents and track your progress to the point of document execution.",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "signDocuments",
      "text": "The status of each section is easy to track for you and HSBC so that any delays can be minimised.",
      "sling:resourceType": "gdocs/components/content/info_graphic",
      "sow-title": "Global Liquidity Solutions – Statement of Work.",
      "sow-text": "Review and approve your Statement of Work for your Liquidity products from HSBC."
    },
    "static_text_passwordText": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "Para acceder al portal, solicite sus datos de inicio de sesión al contacto de HSBC encargado de gestionar su caso.",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "text_box_emailAddress": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Dirección de correo electrónico",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "emailAddress",
      "type": "email",
      "sling:resourceType": "gdocs/components/content/text_box",
      "shortDescription": "Introduzca la dirección de correo electrónico"
    },
    "text_box_password": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Contraseña",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "password",
      "type": "password",
      "sling:resourceType": "gdocs/components/content/text_box",
      "shortDescription": "Introduzca la contraseña"
    },
    "static_text_forgottenPasswordLink": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "¿Ha olvidado su contraseña?",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "checkbox_termsAndConditions": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Términos y condiciones",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "termsAndConditions",
      "text": "Estoy de acuerdo con los",
      "sling:resourceType": "gdocs/components/content/checkbox",
      "shortDescription": "Acepte los términos y condiciones"
    },
    "text_box_generalInformation": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "Ha introducido una combinación incorrecta de dirección de correo electrónico o contraseña",
      "contactText": "Póngase en contacto con el representante de personal de HSBC encargado de su caso para que le envíe una nueva contraseña.",
      "sling:resourceType": "gdocs/components/content/text_box"
    },
    "button_logOn": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "logOn",
      "text": "Iniciar sesión",
      "sling:resourceType": "gdocs/components/content/button"
    }
  }
}

export const LoginDataBA = {
  "jcr:primaryType": "cq:PageContent",
  "jcr:createdBy": "admin",
  "title": "Log in",
  "cq:template": "/apps/gdocs/templates/page-create-case",
  "jcr:language": "en",
  "cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
  "jcr:created": "Wed May 09 2018 11:22:21 GMT+0000",
  "cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
  "cq:cloudserviceconfigs": [
    "[]"
  ],
  "sling:resourceType": "gdocs/components/pages/create-case",
  "cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
  "cq:lastModifiedBy": "admin",
  "par": {
    "jcr:primaryType": "nt:unstructured",
    "sling:resourceType": "wcm/foundation/components/parsys",
    "static_text_customer_guide": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "label": "Terbuka di halaman baru",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "HSBC Global Documentation Manager Customer Guide",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "static_text_sow_guide": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "label": "Opens in new window",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "GLS Statement of Work Customer Guide",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "static_text_introTitle": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "introTitle",
      "text": "Portal untuk mengelola dokumentasi yang berkaitan dengan rekening Anda dan produk-produk manajemen kas dari HSBC.",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "static_text_introDescription": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "description": "Jika Anda mengalami masalah saat menggunakan atau mengakses layanan ini, harap hubungi perwakilan HSBC yang akan membantu Anda mengatasinya.",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "introDescription",
      "text": "Log on untuk melacak permintaan Anda dan melengkapi informasi yang dibutuhkan.  Dokumentasi dapat dibuat dan dilaksanakan untuk memenuhi permintaan Anda.",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "info_graphic_informationToHand": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Sediakan informasi untuk diserahkan",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "informationToHand",
      "text": "HSBC dan Anda akan membutuhkan informasi relevan agar kami dapat menyediakan rekening, E-Channel, dan produk lainnya untuk melanjutkan pembuatan dokumentasi.",
      "sling:resourceType": "gdocs/components/content/info_graphic"
    },
    "info_graphic_saveAsYouGo": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Simpan sambil jalan",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "saveAsYouGo",
      "text": "Untuk menyempurnakan proses pengisian formulir, Anda dan staf HSBC dapat menyimpan kemajuan sementara melengkapi dokumentasi bersama-sama.  Setelah semua lengkap, dokumen final dapat dibuat.  Bila status diperlihatkan sebagai Selesai, masuklah ke bagian ini untuk memastikan semua detail benar dan jika bisa Anda dapat mengisi lebih banyak data untuk memaksimalkan pengalaman online.",
      "sling:resourceType": "gdocs/components/content/info_graphic"
    },
    "info_graphic_signDocuments": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Sign documents and track your progress to the point of document execution.",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "signDocuments",
      "text": "The status of each section is easy to track for you and HSBC so that any delays can be minimised.",
      "sling:resourceType": "gdocs/components/content/info_graphic",
      "sow-title": "Global Liquidity Solutions – Statement of Work.",
      "sow-text": "Review and approve your Statement of Work for your Liquidity products from HSBC."
    },
    "static_text_passwordText": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "Untuk mengakses portal, mintalah detail Log On Anda dari kontak HSBC yang menangani kasus Anda.",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "text_box_emailAddress": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Alamat email",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "emailAddress",
      "type": "email",
      "sling:resourceType": "gdocs/components/content/text_box",
      "shortDescription": "Masukkan Alamat Email"
    },
    "text_box_password": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Kata Sandi",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "password",
      "type": "password",
      "sling:resourceType": "gdocs/components/content/text_box",
      "shortDescription": "Masukkan Kata Sandi"
    },
    "static_text_forgottenPasswordLink": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "Lupa Kata Sandi",
      "sling:resourceType": "gdocs/components/content/static_text"
    },
    "checkbox_termsAndConditions": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "title": "Syarat dan Ketentuan",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "termsAndConditions",
      "text": "Saya setuju dengan",
      "sling:resourceType": "gdocs/components/content/checkbox",
      "shortDescription": "Mohon terima syarat dan ketentuan"
    },
    "text_box_generalInformation": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "text": "Anda memasukkan kombinasi Alamat Email atau Kata Sandi yang salah",
      "contactText": "Hubungi perwakilan staf HSBC yang menangani kasus Anda, yang akan mengatur agar kata sandi baru dikirimkan kepada Anda.",
      "sling:resourceType": "gdocs/components/content/text_box"
    },
    "button_logOn": {
      "jcr:primaryType": "nt:unstructured",
      "jcr:createdBy": "admin",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "name": "logOn",
      "text": "Log On",
      "sling:resourceType": "gdocs/components/content/button"
    }
  }
}

export const getlanguageToggleValues = (index) => {
  // consoleLog('index', 'log', false, index)
  // console.log("index", index)
  switch (index) {
    case 0:
      return ['Language: English', 'Language: Spanish', 'Language: Bahasa']
    case 1:
      return ['Idioma: Ingles', 'Idioma: Espanol', 'Idioma: Bahasa']
    case 2:
      return ['Bahasa: Inggris', 'Bahasa: Spanyol', 'Bahasa: Bahasa']
  }
} 


// WEBPACK FOOTER //
// ./src/components/Login/json_login-in.js